/**
 * 统一用户界面中的日期时间显示，兼容后端 LocalDateTime 的 ISO `T` 格式。
 * 无时区的时间按原值展示，避免把业务时间意外转换时区。
 */
export function displayDateTime(value, fallback = '-') {
  if (value == null || value === '') return fallback
  let normalized = value

  if (typeof value === 'string') {
    const text = value.trim()
    if (!text) return fallback
    const localDateTime = /^(\d{4}[-/]\d{2}[-/]\d{2})[T ](\d{2}:\d{2})(?::(\d{2}))?(?:\.\d+)?$/.exec(text)
    if (localDateTime) return `${localDateTime[1].replaceAll('/','-')} ${localDateTime[2]}:${localDateTime[3] || '00'}`
    const dateOnly = /^(\d{4})[-/](\d{2})[-/](\d{2})$/.exec(text)
    if (dateOnly) return `${dateOnly[1]}-${dateOnly[2]}-${dateOnly[3]} 00:00:00`
    if (!/^\d+$/.test(text)) {
      const parsed = new Date(text)
      if (Number.isNaN(parsed.getTime())) return fallback
      normalized = parsed
    }
  }

  // 带偏移的时间与时间戳是绝对时刻，统一显示业务时区，不随浏览器时区变化。
  if (typeof normalized === 'string' && /^\d+$/.test(normalized)) normalized = Number(normalized)
  if (typeof normalized === 'number' && String(Math.trunc(normalized)).length === 10) normalized *= 1000
  const date = normalized instanceof Date ? normalized : new Date(normalized)
  if (Number.isNaN(date.getTime())) return fallback
  const parts = Object.fromEntries(new Intl.DateTimeFormat('zh-CN', {
    timeZone: 'Asia/Shanghai', hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit'
  }).formatToParts(date).map(part => [part.type, part.value]))
  return `${parts.year}-${parts.month}-${parts.day} ${parts.hour}:${parts.minute}:${parts.second}`
}
